import { ExportTableDialog } from "@/ds";

import { CargaEstado } from "../components/carga-estado";
import { CargaLegend } from "../components/carga-legend";
import { CargaSubbar } from "../components/carga-subbar";
import { CargaToolbar } from "../components/carga-toolbar";
import { ConflictDetailDialog } from "../components/conflict-detail-dialog";
import { GanttFornecedor } from "../components/gantt-fornecedor";
import { GanttFornecedorObras } from "../components/gantt-fornecedor-obras";
import { GanttPrintChrome } from "../components/gantt-print-chrome";
import { IndicadoresDialog } from "@/shared/components/indicadores-dialog";
import { ResolverConflitoFornecedorDialog } from "../components/resolver-conflito-fornecedor";
import type { CargaFornecedorViewModel } from "./types-carga-fornecedor";
import styles from "./carga-fornecedor.module.scss";

/** Carga de Trabalho: perspectiva Fornecedor (US-1774), agrupada por Fornecedor ou por Obra. */
export function CargaFornecedorView({
  estado,
  capaImpressao,
  legendaImpressao,
  toolbar,
  chips,
  removerChip,
  legenda,
  ganttFornecedor,
  ganttObras,
  detalheDoConflito,
  resolver,
  exportacao,
  indicadores,
}: CargaFornecedorViewModel) {
  return (
    <div className={styles.container} data-testid="carga-de-trabalho-screen">
      <GanttPrintChrome {...capaImpressao} legend={<CargaLegend {...legendaImpressao} />} />
      <CargaToolbar {...toolbar} />
      <CargaSubbar chips={chips} onRemoverChip={removerChip}>
        <CargaLegend {...legenda} />
      </CargaSubbar>

      {exportacao.aberta ? (
        <ExportTableDialog
          listName="carga de trabalho"
          isExporting={exportacao.exportando}
          onExport={exportacao.exportar}
          onCancel={exportacao.fechar}
        />
      ) : null}

      {indicadores.aberto ? (
        <IndicadoresDialog
          opcoes={indicadores.opcoes}
          value={indicadores.valor}
          onSave={indicadores.salvar}
          onCancel={indicadores.cancelar}
        />
      ) : null}

      {resolver ? <ResolverConflitoFornecedorDialog {...resolver} /> : null}

      <ConflictDetailDialog {...detalheDoConflito} />

      <CargaEstado {...estado} />
      {ganttFornecedor ? <GanttFornecedor {...ganttFornecedor} /> : null}
      {ganttObras ? <GanttFornecedorObras {...ganttObras} /> : null}
    </div>
  );
}
